import React from "react";
import T from "prop-types";
import { Col } from "react-bootstrap";
import _, { isEqual } from "lodash";

import { AgnosticLoader } from "MODULES/shared/containers";
import api from "APP_ROOT/api";
import { DataTable, CompanyName } from "MODULES/shared/components/index";
import { SUCCESS } from "LIB/submission/constants";
import { FormRow } from "MODULES/shared/components/Forms";
import { API_BASE, CODE, ID } from "APP_ROOT/constants";
import { Formik, Field } from "formik";
import { FormInput } from "MODULES/shared/components/Forms/FormikFormInput/FormInput";
import { connect } from "react-redux";
import { FormikFooter } from "MODULES/shared/components/Forms/FormikForm/FormikFooter";
import { remove } from "LIB/arrays";

class Form extends React.Component {
  static propTypes = {
    close: T.func.required,
    salesItem: T.shape({}),
    salesOrder: T.instanceOf(Map)
  };

  state = {
    results: []
  };

  onItemSelected = id => {
    let items = this.props.includedItems.slice(0);
    if (items.includes(id)) {
      items = remove(items, id);
    } else {
      items.push(id);
    }
    this.props.setIncludedItems(items);
  };

  allItemsSelected = values =>
    isEqual(
      this.props.includedItems.sort(),
      values.coc.map(l => l.sales_order_line_item_id).sort()
    );

  selectAll = values => {
    if (this.allItemsSelected(values)) {
      this.props.setIncludedItems([]);
    } else {
      this.props.setIncludedItems(
        values.coc.map(l => l.sales_order_line_item_id)
      );
    }
  };

  fetch = setValues => id =>
    api.salesOrders.cocSearch(id).then(({ data }) => {
      this.props.setIncludedItems(
        data.results.map(l => l.sales_order_line_item_id)
      );
      setValues({ coc: data.results });
      return SUCCESS;
    });

  renderCompanyLink = item => (
    <div>
      <CompanyName flattenedCompany={item} />
    </div>
  );

  renderResultRow = (item, idx) => (
    <tr key={item.sales_order_line_item_id}>
      <td />
      <td className="text-center">
        <input
          type="checkbox"
          className="radio-inline"
          checked={this.props.includedItems.includes(
            item.sales_order_line_item_id
          )}
          onClick={() => this.onItemSelected(item.sales_order_line_item_id)}
        />
      </td>
      <td>
        {_.get(item, "record_type")}-{_.get(item, "code")}
      </td>
      <td>
        <CompanyName flattenedCompany={item} truncateAt={20} />
      </td>
      <td>
        <FormInput name={`coc[${idx}].obtained_from`} />
      </td>
    </tr>
  );

  render() {
    if (this.props.loading) return null;

    const { includedItems, salesOrder, onSubmit } = this.props;

    return (
      <Formik
        initialValues={{
          coc: [],
          sellersContractNumber: this.props.salesOrder.get(CODE)
        }}
        onSubmit={onSubmit}
      >
        {({
          isSubmitting,
          values,
          setSubmitting,
          handleSubmit,
          setValues,
          ...rest
        }) => (
          <React.Fragment>
            <AgnosticLoader
              fetch={this.fetch(setValues)}
              id={salesOrder.get(ID)}
            >
              {({ loading }) => (
                <DataTable loading={loading} loadingRows={1}>
                  <DataTable.Head>
                    <th />
                    <th className="text-center">
                      <input
                        name="line_items"
                        type="checkbox"
                        onClick={() => this.selectAll(values)}
                        checked={
                          includedItems.length > 0 &&
                          this.allItemsSelected(values)
                        }
                      />
                    </th>
                    <th>Code</th>
                    <th>Company Name</th>
                    <th>Obtained From</th>
                  </DataTable.Head>
                  <DataTable.Body>
                    {values.coc.map(this.renderResultRow)}
                  </DataTable.Body>
                </DataTable>
              )}
            </AgnosticLoader>
            <FormRow>
              <Col md={4}>
                <div className="form-group">
                  <label
                    className="control-label"
                    htmlFor="sellers_contract_number"
                  >
                    Seller&apos;s Contract #:
                  </label>
                  <Field
                    type="text"
                    name="sellers_contract_number"
                    className="form-control"
                  />
                </div>
              </Col>
            </FormRow>
            <FormikFooter
              rest={rest}
              setSubmitting={setSubmitting}
              isSubmitting={isSubmitting}
              isValid={rest.isValid}
              values={{
                coc: values.coc.filter(l =>
                  includedItems.includes(l.sales_order_line_item_id)
                )
              }}
              handleSubmit={handleSubmit}
              close={this.props.close}
              text="Download CoC"
            />
          </React.Fragment>
        )}
      </Formik>
    );
  }
}

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: params => {
    params.coc = params.coc.filter(coc =>
      ownProps.includedItems.includes(coc.sales_order_line_item_id)
    );
    const id = ownProps.salesOrder.get(ID);
    api.salesOrders.createCoc(id, params).then(({ data }) => {
      const url = `${API_BASE}//sales_orders/${id}/download_certificate_of_conformance?cache_key=${data.cache_key}`;
      window.open(url, "_blank");
    });

    ownProps.close();
  }
}))(Form);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadCoC/Form.jsx